import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { refreshJwtToken } from "../../features/slices/UserSlice";

/**
 * Seconds left on the current access token. Derived from the tokenExpires
 * cookie so a page refresh keeps counting the real session, and clamped at 0
 * so the timer never runs into negative values.
 */
function getRemainingSeconds() {
  const expiresAt = Cookies.get("tokenExpires");
  if (!expiresAt) return 0;

  const remainingMs = new Date(expiresAt).getTime() - Date.now();
  if (!Number.isFinite(remainingMs) || remainingMs <= 0) return 0;

  return Math.ceil(remainingMs / 1000);
}

export default function KeepWorkingPopup({ closeModal }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();
  const [remainingTime, setRemainingTime] = useState(getRemainingSeconds);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");

  const formatTime = (timeInSeconds) => {
    const safeSeconds = Math.max(0, timeInSeconds);
    const minutes = Math.floor(safeSeconds / 60);
    const seconds = safeSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(getRemainingSeconds());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Renews the access token so the session actually continues. App.js watches
  // the new expiry and closes the warning on its own, but closing here keeps
  // the popup from lingering for a frame.
  const keepPlaying = async () => {
    if (refreshing) return;
    setRefreshing(true);
    setError("");
    try {
      await dispatch(refreshJwtToken()).unwrap();
      closeModal();
    } catch (err) {
      setRefreshing(false);
      setError(
        err?.error ||
          err?.message ||
          "Could not extend your session. Please log in again."
      );
    }
  };

  const dismissPopup = () => {
    closeModal();
  };

  return (
    <div
      className={`modal fade show payment-completion-modal`}
      style={{
        display: "block",
        backdropFilter: "blur(15px)",
        background: "rgb(70, 70, 70, 0.6)",
      }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content alert-popup">
          <div className="modal-body p-4">
            <div>
              <p className="text--medium">
                Your session will be timed out in {formatTime(remainingTime)}.
                You will be logged out after that(Please be careful).
              </p>
              {error && <p className="text-danger mt-2">{error}</p>}
            </div>
            <div className="btns mt-5">
              <div className={isMobile ? "" : "float-end"}>
                <div className={isMobile ? "d-block" : "d-flex"}>
                  <button
                    className={`close-btn ${isMobile ? "mb-3" : ""}`}
                    onClick={dismissPopup}
                    style={{ width: "130px", marginLeft: "0" }}
                  >
                    Ok
                  </button>
                  <button
                    className={`use-here-btn`}
                    onClick={keepPlaying}
                    disabled={refreshing}
                    style={{ width: "130px", marginRight: "0" }}
                  >
                    {refreshing ? "Please wait..." : "Keep Playing"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
